import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M18 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8" fill="currentColor" />
            <path
                d="M14 12.5a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5V23H2v-4a1.5 1.5 0 0 1 1.5-1.5H8v-1.75a1.5 1.5 0 0 1 1.5-1.5H14z"
                fill="currentColor"
            />
        </svg>
    )
);
EmployersRatingFilledSize24Glyph.displayName = 'EmployersRatingFilledSize24Glyph';
